import RFIDTab from './RFIDTab.vue';
export default RFIDTab;
